import { Component } from '@angular/core';

@Component({
  selector: 'stars-elements-features',
  templateUrl: './elements-features.html',
  styleUrls: ['./elements-features.scss']
})
export class ElementsFeaturesComponent {}
